import React, { useState } from "react";
import Editor from "@monaco-editor/react";
import DarkThemeQuestion from "./darkThemeQuestion";
import GradingBoxQuestion from "./gradingBoxQuestion";
import MarkdownWithLaTeX from "./markDownWithLatex";
import Loading from "./loading";
import ASingleTestGrading from "./aSingleTestGrading";
import FullScreenToggler from "./fullScreenToggler";
import Tippy from "@tippyjs/react";
import Regrade from "./regrade";
import keyValueUpdate from "./keyValueUpdate";

const CodeResponseView = ({ updateAssessmentInformation, useCustomScore, status, error, tests, testsConfigDict, id, updateId, ignoredPaths, ignoredPrefixes, requestLifeCycleTwo, updateContents, useSyntaxHighlighting, location, contents, useAutocompletion, questionNumber, question, language, isDarkTheme, updateIsDarkTheme, points, grading, uuid, pointsEarned, studentAnswer }) => {
    const [answer, setAnswer] = useState(studentAnswer);
    const [fullscreen, setFullscreen] = useState(false);
                
    const updateAField = (key, value) => {
        updateAssessmentInformation((prev) => {
            return keyValueUpdate(prev, uuid, key, value);
        })
    }

    function updateComponentPointsEarned(newValue) {        
        updateAField("pointsEarned", newValue);
    }
    
    function updateUseCustomScoreFromGrading(bool) {
        updateAField("useCustomScore", bool);
    }

    const handleAnswer = (value) => {
        if (!grading) {
            setAnswer(value);
        }
    }

    const handleChange = (value) => {
        if (!grading) {
            updateContents((prev) => ({
                ...prev,
                [location]: {
                    content: value,
                    isDir: false
                }
            }));
        }
    }

    const isValidAndNotIgnoreLocation = contents && location in contents && !(ignoredPaths && location in ignoredPaths) && !(ignoredPrefixes && Array.from(ignoredPrefixes).some(prefix => location.startsWith(prefix)));

    const determineIfWeHaveATestToShow = () => {
        const dictLength = testsConfigDict && Object.keys(testsConfigDict).length > 0;
        
        if (tests && tests.length > 0 && dictLength) {
            for (const key of tests) {
                if (key in testsConfigDict) {
                    return true;
                }
            }
        } else if (error && typeof error === "string") {
            return true;
        }
        
        return false;
    }

    function updateFullscreen(fullscreen) {
        setFullscreen(fullscreen);
    }

    return (
        <>
            <div className="true-false-question-view" id={uuid + "-preview"} >
                <div className="question-number">
                    <div className="grid-number-container">
                        Q{ questionNumber }
                        {
                            grading && (
                                <Tippy content={uuid === id ? "Deselect Answer" : "Select Answer"} placement="right">
                                    <input type={"checkbox"} className="check-auto" checked={uuid === id} onChange={() => {updateId(uuid === id ? "" : uuid)}} style={{ cursor: "pointer" }}/>
                                </Tippy>
                            )
                        }
                    </div>
                    <div className="pts">
                        {
                            useCustomScore && <Regrade previousScore={pointsEarned} updateComponentPointsEarned={updateComponentPointsEarned} updateUseCustomScoreFromGrading={updateUseCustomScoreFromGrading} uuid={uuid}/>
                        }
                        {
                            grading

                            ?

                            <>
                                <GradingBoxQuestion previousScore={pointsEarned} updateComponentPointsEarned={updateComponentPointsEarned} uuid={uuid} pointsEarned={pointsEarned} updateUseCustomScoreFromGrading={updateUseCustomScoreFromGrading}/>
                            </>

                            :

                            <>
                            </>
                        }
                        { (grading ? "/ " : "") + Number(points).toFixed(2) } pts
                    </div>
                </div>
                <div className="true-false-top">
                    <MarkdownWithLaTeX content={question} isDarkTheme={isDarkTheme}/>
                </div>
                <div className="code-response-area-wrapper">
                    {
                        requestLifeCycleTwo ?
                        
                        <>
                            <div className="loading-zip-container">
                                <Loading />
                            </div>
                        </>

                        :

                        <>
                            <div className={`code-response-area ${fullscreen ? "fullscreen-editor-side-bar" : ""}`} style={{ backgroundColor: isDarkTheme ? "var(--vs-background)" : "white", color: isDarkTheme ? "white" : "var(--almost-black)" }}>
                                <div className="code-editor-header" style={{ justifyContent: "space-between" }}>
                                    <div className="location">
                                        {
                                            contents && location in contents ? location.split("/").pop() : <> Programming ({language}) </>

                                        }
                                    </div>
                                    <div className="code-editor-header" style={{ width: "fit-content" }}>
                                        <FullScreenToggler updateFullscreen={updateFullscreen} fullscreen={fullscreen}/>
                                        <DarkThemeQuestion isDarkTheme={isDarkTheme} updateIsDarkTheme={updateIsDarkTheme}/>
                                    </div>
                                </div>
                                <Editor
                                    language={grading ? language : (useSyntaxHighlighting ? language : "plaintext")}
                                    value={isValidAndNotIgnoreLocation ? contents[location].content : answer}
                                    theme={ isDarkTheme ? "vs-dark" : "vs"}
                                    onChange={isValidAndNotIgnoreLocation ? (value) => handleChange(value) : handleAnswer}
                                    options={{
                                        fontFamily: "Consolas, 'Courier New', monospace", // Default font family
                                        fontSize: 14, // Default font size (14px)
                                        tabSize: 8,         // Set tab length to 4 spaces
                                        fontWeight: "500", // Default font weight
                                        suggestOnTriggerCharacters: useAutocompletion,
                                        quickSuggestions: useAutocompletion,  
                                        readOnly: grading,
                                        contextmenu: false                            
                                    }}
                                />
                                <div className="code-editor-header" />
                            </div>
                        </>

                    }                    
                </div>
                {
                    grading && determineIfWeHaveATestToShow() && (
                        // if there is an error or a test to show, show either based on error
                        <div className="true-false-top lambda-results-container">
                            {                                
                                
                                error ? 
                                
                                <div className="stop-overflow-compilation" style={{ color: status === "RUNNING" ? "var(--gray-six)" : "" }}>
                                    See error by navigating to error page
                                </div>

                                :

                                tests.map((id) => {
                                    
                                    if (id in testsConfigDict) {
                                        return <ASingleTestGrading greyedOut={status === "RUNNING"} key={id} {...testsConfigDict[id]}/>
                                    }
                                })
                            }
                        </div>
                    )
                }
            </div>
        </>
    );
}

export default CodeResponseView;